/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import Card from "./Card";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: "top",
    },
    title: {
      display: false,
      text: "Chart.js Line Chart",
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      backgroundColor: "#1f2937",
      titleColor: "#fff",
      bodyColor: "#d1d5db",
      borderColor: "#4b5563",
      borderWidth: 1,
      callbacks: {
        title: () => "Oqim tezligi",
        label: function (context) {
          const value = context.formattedValue;
          return `${value} m³/s`;
        },
      },
    },
  },
  scales: {
    y: {
      grid: {
        color: "#B5B5C3",
      },
      border: {
        dash: [2, 2],
      },
      stacked: true,
      beginAtZero: true,
    },
    x: {
      grid: {
        drawOnChartArea: false,
        display: true,
        color: "#B5B5C3",
      },
      ticks: {
        stepSize: 0.5,
      },
    },
  },
};

const Chart3 = ({ data }) => {
  const gradient = (ctx) => {
    const chart = ctx.chart;
    const { ctx: context, chartArea } = chart;

    if (!chartArea) return;

    const gradient = context.createLinearGradient(
        0,
        chartArea.top,
        0,
        chartArea.bottom
    );
    gradient.addColorStop(0, "rgba(79, 187, 255, 0.52)");
    gradient.addColorStop(1, "rgba(34,197,94,0)");

    return gradient;
  };

  const datas = {
    // TUZATILDI: Obyekt ildizidagi ortiqcha data: data olib tashlandi
    datasets: [
      {
        label: "m3/s",
        data: data,
        borderColor: "rgb(255,255,255)",
        backgroundColor: gradient,
        fill: true,
      },
    ],
  };

  return (
      <Card>
        <div className='chart-box-all'>
          <div>
            {/* TUZATILDI: "kunlik" so'zi xira va moslashuvchan uslubda qo'shildi */}
            <h4 className='chart-title'>
              Oqjar G/P{" "}
              <span className='lower' style={{ opacity: 0.75, marginLeft: '4px' }}>
              kunlik (m<sup>3</sup>/s)
            </span>
            </h4>
            <Line options={options} data={datas} height={80} />
          </div>
        </div>
      </Card>
  );
};

export default Chart3;